import type { MedicationProduct } from '../shared';

export const trulicityProducts: MedicationProduct[] = [
    {
        description: 'Trulicity® Autoinjector 0.75 mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 0.75,
        imageUrl: '/static/img/trulicity-0.75mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002143380', packageQuantity: 1 },
            { ndc: '00002143301', packageQuantity: 1 },
        ],
        pricing: { selfPay: 389 },
        headlinePrices: [{ type: 'DiscountedCashPrice', value: 389 }],
        pathway: {
            initialPathway: 'self-pay',
        },
    },
    {
        description: 'Trulicity® Autoinjector 1.5 mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 1.5,
        imageUrl: '/static/img/trulicity-1.5mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002143480', packageQuantity: 1 },
            { ndc: '00002143401', packageQuantity: 1 },
        ],
        pricing: { selfPay: 389 },
        headlinePrices: [{ type: 'DiscountedCashPrice', value: 389 }],
        pathway: {
            initialPathway: 'self-pay',
        },
    },
    {
        description: 'Trulicity® Autoinjector 3 mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 3,
        imageUrl: '/static/img/trulicity-3mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002223680', packageQuantity: 1 },
            { ndc: '00002223601', packageQuantity: 1 },
        ],
        pricing: { selfPay: 389 },
        headlinePrices: [{ type: 'DiscountedCashPrice', value: 389 }],
        pathway: {
            initialPathway: 'self-pay',
        },
    },
    {
        description: 'Trulicity® Autoinjector 4.5 mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 4.5,
        imageUrl: '/static/img/trulicity-4.5mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002318280', packageQuantity: 1 },
            { ndc: '00002318201', packageQuantity: 1 },
        ],
        pricing: { selfPay: 389 },
        headlinePrices: [{ type: 'DiscountedCashPrice', value: 389 }],
        pathway: {
            initialPathway: 'self-pay',
        },
    },
];
